import { useState, useEffect } from 'react'
import { getClient } from '../libs/DBApiHandler'
import { DropinPackage } from '../../../pure-js/types/GrooverTypes'
import { DEFAULT_CURRENCY, getCurrencyForClient } from '../../../pure-js/libs/currencyHelper'

export const useDropinPackages = (clientId?: string) => {
  const [packages, setPackages] = useState<DropinPackage[]>([])
  const [currency, setCurrency] = useState(DEFAULT_CURRENCY)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let isMounted = true

    const fetchClient = async () => {
      if (!clientId) {
        if (isMounted) {
          setPackages([])
          setLoading(false)
          setError(null)
        }
        return
      }

      if (isMounted) {
        setLoading(true)
        setError(null)
      }

      try {
        const clientData = await getClient(clientId)
        if (!isMounted) return

        if (clientData) {
          setPackages((clientData.dropinPackages || []).filter((pkg) => pkg.isActive !== false))
          setCurrency(getCurrencyForClient(clientData))
        } else {
          setError('Client not found')
        }
      } catch (err) {
        if (isMounted) {
          setError(err instanceof Error ? err.message : 'Failed to fetch client data')
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchClient()

    return () => {
      isMounted = false
    }
  }, [clientId])

  return {
    packages,
    currency,
    loading,
    error
  }
}
